module.exports = __webpack_public_path__ + "img/02b-shift-form.c1cbbb33.png";